/* eslint-disable import/prefer-default-export */

export const updateLanguage = (language) => ({
  type: 'UPDATE_LANGUAGE',
  payload: {
    language,
  },
});
